import { render, staticRenderFns } from "./ContactoSection.vue?vue&type=template&id=4522beaa&scoped=true"
import script from "./ContactoSection.vue?vue&type=script&lang=js"
export * from "./ContactoSection.vue?vue&type=script&lang=js"
import style0 from "./ContactoSection.vue?vue&type=style&index=0&id=4522beaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4522beaa",
  null
  
)

export default component.exports